import { DateTime } from "luxon";
import * as z from "zod";

// Custom function to validate DateTime.
// Accepts either a valid ISO string or a DateTime object and transforms to DateTime<true>.
export const zDateTimeSchema = z
    .custom<string | DateTime>(
        (value) =>
            (typeof value === "string" && DateTime.fromISO(value).isValid) ||
            (DateTime.isDateTime(value) && value.isValid),
        { error: "Invalid DateTime" },
    )
    .transform((value): DateTime<true> =>
        typeof value === "string"
            ? (DateTime.fromISO(value) as DateTime<true>)
            : (value as DateTime<true>),
    );
